import React from "react";
import { Link } from "react-router-dom";
import { BaseUrl } from "../../helper/BaseUrl";

export default function DynamicHeaderSection({ aiData, onAction }) {
  return (
    <section className="dynamic-header-section" aria-labelledby="dynamic-header-title">
      <div className="container">
        <div className="row align-items-center justify-content-between dynamic-header-row">
          <div className="col-xl-5 col-lg-6 col-md-6">
            <div className="dynamic-header-content">
              <nav className="main-title dynamic-header-breadcrumbs" aria-label="Breadcrumb">
                <Link to="/">Home</Link>
                <span aria-hidden="true">|</span>
                <span aria-current="page">{aiData?.hero?.title ? aiData?.hero?.title.slice(0, 20) + "..." : ""}</span>
              </nav>
              <h1 id="dynamic-header-title" className="heading">{aiData?.hero?.title}</h1>
              <div className="dynamic-header-description"  dangerouslySetInnerHTML={{ __html: aiData?.hero?.description }} />
              <div className="btn-wrapper">                 
              <button type="button" className="default-btn white-font" onClick={onAction}>
               {aiData?.hero?.buttonText}
              </button>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
          <img src={`${BaseUrl}${aiData?.hero?.image}`}  className="img-responsive dynamic-header-image"  alt={aiData?.hero?.imageAlt}    loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}
